import { emitEvent as _emitEvent } from "../../../../AnalyticsTracking/emit-event";
import { EventType } from "../../../../AnalyticsTracking/events";

export const emitEvent = (
  commandName: EventType,
  data: Record<string, unknown> | undefined,
  isSpaEvent: boolean
) => {
  _emitEvent(commandName, data, isSpaEvent);
};
